// extracted by mini-css-extract-plugin
export default {"sidebarData":"Sidebar_sidebarData__gCXQD","sidebarDescription":"Sidebar_sidebarDescription__kPK1a","sidebarLabel":"Sidebar_sidebarLabel__H7Buk"};